module.exports = __webpack_public_path__ + "static/media/Opeyemi.3abbff92.png";